module.exports = __webpack_public_path__ + "resources/img/img_gridgain_apache2_jp.24a54fd868f65069261591b29231ed6e.png";